// removed by extract-text-webpack-plugin
module.exports = {"tips":"_2n2Bx2bSx4TjYBnsqpw5gO","title":"_37u6xpl1mLke4tMHaLjQ7H","text":"_1MiMtpQpHL_7J3b7BYAFCJ"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/molecules/SprintaTips/style.module.css
// module id = 470
// module chunks = 38